module.exports = __webpack_public_path__ + "static/media/vehicle.360e0939.svg";